import React, { useState, useEffect } from 'react';
import { Descriptions, Tooltip, Button } from 'antd';
import moment from 'moment';
import formatTimestamp from "../utils/FormatTimestamp";

/*
  Componente que muestra la información de la reunión
  @meeting: objeto que contiene la información de la reunión
*/
const MeetingInformation = ({ meeting }) => {  
  const [details, setDetails] = useState([]);
  
  useEffect(() => {
    showMeetingDetails(meeting);
  }, [meeting]);

  const showMeetingDetails = (data) => {
    let meetingTemp = data;
    if (!meetingTemp) {
      return;
    }
    const duration = moment(meetingTemp.endDate).diff(
      moment(meetingTemp.startDate),
      "minutes"
    );
    //get all duration of the meeting_point_details list
    let durationPoints = 0;
    data?.meeting_point_details.forEach((element) => {
      durationPoints += element.duration;
    });

    setDetails([
      {
        key: 6,
        label: "Fecha",
        children: formatTimestamp(meetingTemp.startDate)
      },
      // {
      //   key: 1,
      //   label: "ID",
      //   children: meetingTemp.id,
      // },
      {
        key: 2,
        label: "Nombre de la reunión",
        children: meetingTemp.title_meeting,
      },
      {
        key: 2,
        label: "Tipo de reunión",
        children: meetingTemp.meeting_type_name,
      },
      {
        key: 4,
        label: "Departamento",
        children: meetingTemp.department_name,
      },
      {
        key: 5,
        label: "Periodicidad",
        children: meetingTemp.periodicities.name,
      },
      {
        key: 7,
        label: "Duración",
        children: `${duration} min`,
      },
      {
        key: 8,
        label: "Anfitrión",
        children: meetingTemp.creator,
      },
      {
        key: 9,
        label: "Co-Anfitrión",
        children: meetingTemp.co_host,
      },
      {
        key: 10,
        label: "Tiempo total agenda",
        children: (durationPoints > duration) ? <Tooltip title="La duración total de los puntos de reunión es mayor a la duración de la reunión"><span style={{color: "red"}}>{durationPoints} min</span></Tooltip> : `${durationPoints} min`,
      },
      {
        key: 11,
        label: "Invitados",
        children: getGuests(meeting),
      },
      {
        key: 12,
        label: "Informados",
        children: getInformados(meeting),
      },
      {
        key: 13,
        label: "Estatus",
        children: meetingTemp.status.name,
      },
    ]);
  };

  const getGuests = (record) => {
    if (record.meeting_guests == null || record.meeting_guests === undefined) {
      return (
        <Button type="link">Sin invitados</Button>
      )
    }
    const guestList = Array.isArray(record.meeting_guests)
    ? record.meeting_guests.map(guest => guest.email.trim())
    : record.meeting_guests.split(',').map(guest => guest.trim());
    if (guestList === null || guestList === undefined || guestList.length === 0 || guestList === "") {
      return (
        <Button type="link">Sin invitados</Button>
      )
    }
    const g = guestList.map((guest, index) => {
      return <div key={index}>{guest}</div>
    })
    if (guestList.length === 1) {
      if (guestList[0] === "") {
        return (
          <Button type="link">Sin invitados</Button>
        )
      }
    }
    return (
    <Tooltip title={g}>
      <Button type="link">{`${guestList.length} `}{(guestList.length > 1) ? `personas` : `persona`}</Button>
    </Tooltip>
    )
  }

  const getInformados = (record) => {
    if (record.informated_people == null || record.informated_people === undefined) {
      return (
        <Button type="link">Sin informados</Button>
      )
    }
    const guestList = Array.isArray(record.informated_people)
    ? record.informated_people.map(guest => guest.email.trim())
    : record.informated_people.split(',').map(guest => guest.trim());
    if (guestList === null || guestList === undefined || guestList.length === 0 || guestList === "") {
      return (
        <Button type="link">Sin informados</Button>
      )
    }
    const g = guestList.map((guest, index) => {
      return <div key={index}>{guest}</div>
    })
    if (guestList.length === 1) {
      if (guestList[0] === "") {
        return (
          <Button type="link">Sin invitados</Button>
        )
      }
    }
    return (
    <Tooltip title={g}>
      <Button type="link">{`${guestList.length} `}{(guestList.length > 1) ? `personas` : `persona`}</Button>
    </Tooltip>
    )
  }

  return (
    <Descriptions bordered title="Información" items={details} />
  );
}

export default MeetingInformation;